import React from "react";

import Container from "react-bootstrap/Container";
import { Navbar } from "react-bootstrap";

import { NavbarResponsive } from "../../common/components/NavbarResponsive";
import Logo from "../../common/images/logo.png";

export default function DatabaseHeader() {
  return (
    <NavbarResponsive>
      <Container>
        <div></div>
        <div>
          <Navbar.Brand className="align-self-center">
            <img
              className="d-block"
              width={80}
              src={Logo}
              alt="Federico Bartoli PT"
            />
          </Navbar.Brand>
        </div>
        <div></div>
      </Container>
    </NavbarResponsive>
  );
}
